import { render, staticRenderFns } from "./RegisterProposal.vue?vue&type=template&id=16f5de6d&"
import script from "./RegisterProposal.vue?vue&type=script&lang=js&"
export * from "./RegisterProposal.vue?vue&type=script&lang=js&"
import style0 from "./RegisterProposal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports